<template lang="pug">
div
  v-form(ref="form")
    v-card.round-lg(outlined)
      .pa-6
        v-row
          v-col(cols="7")
            div.text-md.font-semibold.neutral700--text WhatsApp Deliverance
            div.text-sm.neutral700--text Configure your offers WhatsApp
            v-textarea.text-sm.mt-2.round-xl(ref="textarea" v-model="blast.content" placeholder="Type your message here" outlined rows="6" hide-details="auto" :rules="rules.not_empty" @input="updateCursor" @change="updateCursor" @focus="updateCursor")
            template(v-if="offer.redeem_method != 'show_message'")
              div.text-sm.font-semibold.neutral700--text.mt-5 Insert field:
              v-chip.mt-1(link small outlined color="neutral400" @click="insertValue('offer_code')")
                span.neutral700--text Promo code

            div.text-md.font-semibold.neutral700--text.mt-4 Send message after
            v-row.mt-2(dense)
              v-col(cols="5")
                v-text-field.text-sm.round-xl(v-model="blast.auto_send_delay_time_value" placeholder="Enter value" outlined dense height="48" type="number" :rules="rules.not_empty" hide-details="auto")
              v-col(cols="5")
                y-select(v-model="blast.auto_send_delay_time_unit" placeholder="Select duration" attach menuPosition="top" :items="duration" item-text="text" item-value="value" :rules="rules.not_empty_select")

          v-divider.neutral300.my-n3(vertical)
          v-col(cols="5")
            whatsapp-preview(title="Offer message preview" :content="blast.content")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import WhatsappPreview from '@/components/clinic/marketing/WhatsappPreview.vue'

export default {
  components: { WhatsappPreview },
  props: {
    blastData: {
      type: Object,
      default: null
    },
    offer: {
      type: Object,
      default: (() => {})
    }
  },
  data () {
    return {
      isFetching: false,
      isLoading: false,
      cursorPosition: 0,
      blast: {},
      duration: [
        { text: 'Seconds', value: 'seconds'},
        { text: 'Minutes', value: 'minutes'},
        { text: 'Hours', value: 'hours'},
        { text: 'Days', value: 'days'},
      ],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    textarea () {
      return this.$refs.textarea.$el.querySelector('textarea')
    }
  },
  watch: {
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      if (this.blastData) {
        let blast = JSON.parse(JSON.stringify(this.blastData))
        this.blast = blast
      }
    },
    updateCursor () {
      const postion = this.textarea.selectionStart
      if (!postion) {
        setTimeout(() => {
          this.cursorPosition = this.textarea.selectionStart
        }, 500)
      } else {
        this.cursorPosition = this.textarea.selectionStart
      }
    },
    insertValue (value) {
      let text = ''
      let code = ''
      if (this.offer.redeem_method === 'general_code') {
        code = this.offer.coupon_code
      } else {
        code = `{{ ${value} }}`
      }
      if (this.blast.content) {
        text = `${this.blast.content.substring(0, this.cursorPosition)}${code}${this.blast.content.substring(this.cursorPosition, this.blast.content.length)}`
      } else {
        text = code
      }
      this.$set(this.blast, 'content', text)
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        return
      }
      this.isLoading = true
      let payload = {
        name: 'Google Review',
        method: 'whatsapp',
        type: 'review',
        content: this.blast.content,
        send_cue: 'review_assigned',
        send_to: 'reviewer',
        auto_send_delay_time_value: this.blast.auto_send_delay_time_value,
        auto_send_delay_time_unit: this.blast.auto_send_delay_time_unit,
      }
      if (this.blast.id) {
        this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts/${this.blast.id}`, payload)
          .then(() => {
            this.$emit('updated')
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        this.$axios.post(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts`, payload)
          .then(() => {
            this.$emit('updated')
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>

::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>